import MuiSelect from '@mui/material/Select'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { cond } from 'lodash-es'
import styled from '@emotion/styled'

const StyledSelect = styled(MuiSelect)`
  ${({ theme, disabled, $hasSelection, $size, $color }) => `
    font-size: ${
      $size === 'large'
        ? theme.typography.body1.fontSize
        : $size === 'medium'
        ? '16px'
        : $size === 'small'
        ? '14px'
        : theme.typography.h6.fontSize
    };

    &::before, &::after {
      border-bottom: none !important;
    }

    #selector {
      padding-left: 10px;
      &:focus {
        background-color: initial;
      }
    }

    #service-info {
      ${disabled ? `background-color: ${theme.palette.background.gray}` : ''};
    }

    color: ${cond([
      [() => disabled && $hasSelection, () => theme.palette.text.minus2],
      [() => disabled && !$hasSelection, () => theme.palette.text.secondary],
      [
        () => $hasSelection,
        () =>
          $color === 'primary'
            ? theme.palette.primary.main
            : theme.palette.text.minus2, // $color === 'text'
      ],
      [() => true, () => theme.palette.text.secondary],
    ])()};
    ${disabled ? `background-color: ${theme.palette.background.gray}` : ''};
    div[role="button"] {
      ${
        $size === 'medium'
          ? `padding: 12px ${$hasSelection ? '32px' : '16px'} 12px 15px;`
          : ''
      }
      ${
        $size === 'small'
          ? `padding: 10px ${$hasSelection ? '32px' : '16px'} 10px 10px;`
          : ''
      }
    }
    ${
      $size === 'medium'
        ? `#selector { padding: 12px ${
            $hasSelection ? '32px' : '16px'
          } 12px 15px; }`
        : ''
    }
    ${
      $size === 'small'
        ? `#selector { padding: 10px ${
            $hasSelection ? '32px' : '16px'
          } 10px 10px; }`
        : ''
    }
  `}
`

const StyledExpandMoreIcon = styled(ExpandMoreIcon)`
  ${({ theme }) => `
    fill: ${theme.palette.text.disabled};
  `}
`

const MainTextExpandMoreIcon = styled(ExpandMoreIcon)`
  ${({ theme }) => `
    padding-right:8px;
    fill: ${theme.palette.text.primary};
  `}
`

const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)`
  ${({ theme }) => `
    padding-right:8px;
    fill: ${theme.palette.text.disabled};
  `}
`

const chooseIconByColor = (color, size = 'medium') => {
  if (size === 'small') {
    return StyledArrowDropDownIcon
  }
  if (color === 'textPrimary') {
    return MainTextExpandMoreIcon
  }
  return StyledExpandMoreIcon
}

const Select = ({
  label,
  value,
  onChange,
  disabled,
  IconComponent,
  size,
  color,
  iconColor,
  children,
  muiLabel,
  labelId,
  ...rest
}) => {
  return (
    <StyledSelect
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={muiLabel}
      labelId={labelId}
      $hasSelection={!!value || value === 0 || value === false}
      $size={size}
      $color={color}
      {...rest}
      inputProps={{
        id: 'selector',
      }}
      IconComponent={IconComponent || chooseIconByColor(iconColor, size)}
    >
      {!!rest?.native && (
        <option value="" disabled>
          {label}
        </option>
      )}
      {children}
    </StyledSelect>
  )
}

Select.defaultProps = {
  native: true,
  value: '',
  size: 'default',
  color: 'primary',
}

export default Select
